module.exports = __webpack_public_path__ + "static/crm_pic.4ccb41ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crm_pic.png
// module id = 3070
// module chunks = 213231404188204